<template>
  <div>
   <div class="box-card" style="width: 100%;margin: 0 auto">
   
     <div class="el-row"> 
      <div class="el-col-12">
        <div style='text-align: left;'>
          <div class="el-row roww">
            <div class="el-col-6 " style='text-align: right;'>项目名称：</div><div class="el-col-12 coll">{{item.name}}</div>
          </div>
          <div class="el-row roww">
              <div class="el-col-6 " style='text-align: right;'>项目描述：</div><div class="el-col-12 coll">{{item.desc}}</div>
          </div>
          <div class="el-row roww">
            <div class="el-col-6 " style='text-align: right;'>报名时间：</div><div class="el-col-12 coll">{{item.start_time}}</div>
          </div>
          <div class="el-row roww">
            <div class="el-col-6 " style='text-align: right;'>报名截止时间：</div><div class="el-col-12 coll">{{item.end_time}}</div>
          </div>
          <!-- <div class="el-row roww">
            <div class="el-col-6 " style='text-align: right;'>项目标签：</div><div class="el-col-12 coll">{{item.label_name }}</div>
          </div> -->
          <div class="el-row roww">
            <div class="el-col-6 " style='text-align: right;'>主板单位：</div><div class="el-col-12 coll">{{item.sponsor }}</div>
          </div>
          <div class="el-row roww">
            <div class="el-col-6 " style='text-align: right;'>协办单位：</div><div class="el-col-12 coll">{{item.organizer }}</div>
          </div>
          <div class="el-row roww">
            <div class="el-col-6 " style='text-align: right;'>学时：</div><div class="el-col-12 coll">{{item.period }}</div>
          </div>
           <div class="el-row roww">
            <div class="el-col-6 " style='text-align: right;'>辅导员评分占比：</div><div class="el-col-12 coll">{{item.prportion }}</div>
          </div>
          <div class="el-row roww">
            <div class="el-col-6 " style='text-align: right;'>培训开始时间：</div><div class="el-col-12 coll">{{item.start_stydy_time }}</div>
          </div>
          <div class="el-row roww">
            <div class="el-col-6 " style='text-align: right;'>培训截止时间：</div><div class="el-col-12 coll">{{item.end_study_time }}</div>
          </div>
          <!-- <div class="el-row roww">
            <div class="el-col-6 " style='text-align: right;'>状态：</div><div class="el-col-12 coll">{{item.onsale }}</div>
          </div> -->
        </div>
      </div>
      <div class="el-col-12">
       <div style='text-align: left;'>
        <div class="el-row roww">
          <div class="el-col-6 " style='text-align: right;'>项目任务：</div><div class="el-col-12 coll">
          <div v-for="data,index in tableData">
          {{data.task_name}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 

</div>

</div>
</template>

<script>
  export default {
    props: {
      item:'',
      tableData:'',
    }
    ,
    data() {
      return {
       
     
      }
    },
    methods: {



    },
    mounted () {

    },
    created(){
  

   },

 }
</script>

<style scoped>
  .roww{
    padding: 14px 0;
    color: #aaa;

  }
  .coll{
    padding-left:10px;
    color: #000;
  }

</style>